import React from 'react';

import PoiDistanceListItem from './PoiDistanceListItem';
import NearbyHut from 'models/NearbyHut';

function PoiDistanceList({ pois }: { pois: NearbyHut[] }) {
    return (
        <div className="space-y-4">
            {pois.map((p) => (
                <PoiDistanceListItem
                    key={p.id}
                    type={p.hut.type?.slug}
                    name={p.hut.name}
                    slug={p.hut.slug}
                    distance={p.distance}
                />
            ))}
        </div>
    );
}

export default PoiDistanceList;
